module.exports = __webpack_public_path__ + "static/media/Close_Icon.b07307fe.svg";